import { Leaflet } from 'containers/maps';

import markerIcon from './map/marker-icon.png';
import markerIconBig from './map/marker-icon-big.png';

const markerIcons = {
  standart: markerIcon,
  standartBig: markerIconBig
};

const markerSizes = {
  standart: [40, 48],
  standartBig: [54, 67]
};

export default function marker(icon = 'standart') {
  if (__SERVER__) return null; // eslint-disable-line
  const size = markerSizes[icon] || markerSizes.standart;
  return Leaflet.icon({
    // iconUrl: markerIcons[icon],
    iconUrl: markerIcons[icon] || markerIcons.standart,
    iconSize: size,
    shadowSize: [0, 0],
    iconAnchor: [size[0] / 2, size[1] - 7],
    shadowAnchor: [0, 0]
  });
}
